import React from 'react';
import { Field } from '@ark-ui/react/field';
import clsx from 'clsx';
import type { BaseInputProps } from '../../types/inputs';
import styles from './inputs.module.scss';

export interface TextareaInputProps extends BaseInputProps<string> {
  /** Počet viditelných řádků. */
  rows?: number;
  className?: string;
}

/**
 * Atomický víceřádkový textový input postavený na Ark UI `Field.Textarea`.
 */
export const TextareaInput: React.FC<TextareaInputProps> = ({
  name,
  id,
  value,
  onChange,
  onBlur,
  ref,
  disabled,
  readOnly,
  hasError,
  required,
  placeholder,
  describedBy,
  testAttributes,
  rows = 4,
  className,
}) => (
  <Field.Root
    invalid={hasError}
    disabled={disabled}
    readOnly={readOnly}
    required={required}
  >
    <Field.Textarea
      id={id}
      ref={ref}
      name={name}
      rows={rows}
      value={value ?? ''}
      placeholder={placeholder}
      onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
        onChange(event.target.value)
      }
      onBlur={onBlur}
      className={clsx(styles.textarea, className)}
      aria-describedby={describedBy}
      {...testAttributes}
    />
  </Field.Root>
);

TextareaInput.displayName = 'TextareaInput';
